module.exports = __webpack_public_path__ + "static/video3-56637df448b2d098cb34dfb414757868.mp4";